export function formatNaira(n: number | undefined | null, opts: { compact?: boolean } = {}): string {
  if (n == null || isNaN(n)) return '—';
  if (opts.compact) {
    if (n >= 1_000_000_000) return `₦${(n / 1_000_000_000).toFixed(1)}B`;
    if (n >= 1_000_000)     return `₦${(n / 1_000_000).toFixed(1)}M`;
    if (n >= 1_000)         return `₦${(n / 1_000).toFixed(1)}K`;
  }
  return '₦' + n.toLocaleString('en-NG', { maximumFractionDigits: 0 });
}

export function formatCount(n: number | undefined | null): string {
  if (n == null || isNaN(n)) return '—';
  return n.toLocaleString('en-US');
}

export function formatDuration(seconds: number | undefined | null): string {
  if (!seconds) return '—';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  return h > 0 ? `${h}h ${m}m` : `${m}:${String(s).padStart(2, '0')}`;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
}

export function formatDate(iso: string | undefined | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toISOString().slice(0, 10);
}

export function formatDateTime(iso: string | undefined | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const date = d.toISOString().slice(0, 10);
  const time = d.toTimeString().slice(0, 5);
  return `${date} ${time}`;
}

export function relativeTime(iso: string | undefined | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  const now = Date.now();
  const diff = (now - d.getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 30) return `${Math.floor(diff / 86400)}d ago`;
  return formatDate(iso);
}

// Short "description" shown in lists/dashboard, auto-derived from the Yoruba
// transcript: first DESCRIPTION_CAP chars, trimmed, with a "..." postfix when
// the source is longer than the cap. Mirrors the legacy MediaForm behavior.
export const DESCRIPTION_CAP = 30;

export function deriveDescription(transcriptText: string | undefined | null): string {
  if (!transcriptText) return '';
  let description = transcriptText.substring(0, DESCRIPTION_CAP).trim();
  if (transcriptText.length > DESCRIPTION_CAP) description += '...';
  return description;
}

export function formatPct(n: number, withSign = true): string {
  if (n == null || isNaN(n)) return '—';
  const sign = n > 0 ? '+' : '';
  return (withSign ? sign : '') + n.toFixed(1) + '%';
}
